import myaxios from '../utils/myaxios'

export function getCouponList(data) {
    return myaxios({
        url: '/manager/coupon/couponList',
        data,
        method: 'post'
    })
}

export function checkIccid(data) {
    return myaxios({
        url: '/manager/coupon/checkIccid',
        data,
        method: 'post'
    })
}

export function saveCoupon(data) {
    return myaxios({
        url: '/manager/coupon/saveCoupon',
        data,
        method: 'post'
    })
}


export function copyCoupon(id) {
    return myaxios({
        url: '/manager/coupon/copyCoupon/'+id,
        method: 'post'
    })
}

export function delCoupon(id) {
    return myaxios({
        url: '/manager/coupon/delCoupon/'+id,
        method: 'post'
    })
}


export function partCoupon(id) {
    return myaxios({
        url: '/manager/coupon/partCoupon/'+id,
        method: 'post'
    })
}

export function addPart(data) {
    return myaxios({
        url: '/manager/coupon/addPart',
        data,
        method: 'post'
    })
}

export function delPart(id) {
    return myaxios({
        url: '/manager/coupon/delPart/'+id,
        method: 'post'
    })
}

export function importPart(id) {
    return myaxios({
        url: '/manager/coupon/importPart/'+id,
        method: 'post'
    })
}


export function couponOrderList(data) {
    return myaxios({
        url: '/manager/couponOrder/couponOrderList',
        data,
        method: 'post'
    })
}


export function receiveCoupon(data) {
    return myaxios({
        url: '/manager/coupon/receiveCoupon',
        data,
        method: 'post'
    })
}


export function getCoupon(id) {
    return myaxios({
        url: '/manager/coupon/getCoupon/'+id,
        method: 'post'
    })
}


export function getGiveCoupon() {
    return myaxios({
        url: '/manager/coupon/getGiveCoupon/',
        method: 'post'
    })
}




